var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.modals),function(modal){return _c('base-modal',{key:modal.id,attrs:{"modal":modal}},[_c(modal.name,{tag:"component",attrs:{"modal":modal}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }